import React from 'react';
import { BookOpenIcon } from 'lucide-react';
import { Card } from './ui/Card';
export function ProductReveal() {
  return <section className="py-5 px-4 sm:px-6 lg:px-8 bg-black relative overflow-hidden" data-id="element-166">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-green-500/5 rounded-full blur-3xl pointer-events-none" data-id="element-167"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-168">
        <div className="text-center mb-4" data-id="element-169">
          <span className="inline-block px-3 py-1 text-xs font-bold bg-gray-800 text-green-500 rounded-full uppercase tracking-wider mb-2 border border-green-500/30" data-id="element-170">
            Presentamos el sistema que reúne todo en un solo lugar
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-2" data-id="element-171">
            MEGA PACK INGRESO A LAS FUERZAS
          </h2>
          <p className="text-lg md:text-xl text-gray-300 max-w-2xl mx-auto leading-snug" data-id="element-172">
            Un sistema pensado para aspirantes que quieren prepararse de verdad,
            con material organizado y enfocado en las etapas que más eliminan.
          </p>
        </div>

        <Card className="p-4 md:p-6 border-green-500/20 bg-gradient-to-br from-gray-900 to-black" data-id="element-173">
          <h3 className="text-2xl md:text-3xl font-bold text-green-500 mb-3 text-center" data-id="element-174">
            ¿Qué incluye el producto principal?
          </h3>

          <div className="flex flex-col md:flex-row items-center md:items-start gap-3" data-id="element-175">
            <div className="flex-shrink-0 bg-green-500/10 p-3 rounded-xl border border-green-500/30" data-id="element-176">
              <BookOpenIcon className="w-10 h-10 text-green-500" data-id="element-177" />
            </div>
            <div data-id="element-178">
              <h4 className="text-xl md:text-2xl font-bold text-white mb-1" data-id="element-179">
                Mega Pack Ingreso a las Fuerzas
              </h4>
              <p className="text-base md:text-lg text-gray-300 mb-1 leading-snug" data-id="element-180">
                Una guía base y central para entender el proceso de ingreso,
                prepararte mejor y saber cómo avanzar con más claridad.
              </p>
              <p className="text-base md:text-lg text-gray-400 leading-snug" data-id="element-181">
                Este manual funciona como el núcleo del sistema y te permite
                tener una visión más ordenada de todo el camino de preparación.
              </p>
            </div>
          </div>
        </Card>
      </div>
    </section>;
}